import { render } from "./dentrion_intro.vue?vue&type=template&id=abb66f7a&scoped=true"
import script from "./dentrion_intro.vue?vue&type=script&lang=js"
export * from "./dentrion_intro.vue?vue&type=script&lang=js"

import "./dentrion_intro.vue?vue&type=style&index=0&id=abb66f7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb66f7a"]])

export default __exports__